import React, { useRef, useEffect, useState } from 'react';

const About = ({ }) => {
    

    return (
        <div>
            <p>Some text etc</p>
        </div>
    );

}

export default About;